export default __webpack_public_path__ + "static/media/plus.022182d6.svg";